<template>
    <input v-if="showinput !== true" :type="type ?? 'text'" @change="$emit('change')" @keyup="$emit('keyup')" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
        :class="getClasses()" :placeholder="placeholder ?? ''" :id="idinput ?? null" :max="max" :min="min" :step="step" :disabled="disabled" />
    <input v-if="showinput !== false" :type="'text'" :value="modelValue" @change="$emit('change')" @keyup="$emit('keyup')" @input="$emit('update:modelValue', $event.target.value)"
        :class="getClasses()" :placeholder="placeholder ?? ''" :id="idinput ?? null" :max="max" :min="min" :step="step" :disabled="disabled" :required="required" />
    <div v-if="type == 'password' && showable == true" @click="showinput=!showinput" class="d-flex flex-row align-items-center px-2" style="position: absolute; top: 0; bottom: 0; right: 0; cursor: pointer;">
        <font-awesome-icon v-if="showinput!==true" icon="fa-solid fa-eye" />
        <font-awesome-icon v-if="showinput===true" icon="fa-solid fa-eye-slash" />
    </div>
</template>

<style scoped>
.form-control {
    border-radius: 0.25rem;
}
.show-input {
    -webkit-text-security: unset !important;
}
</style>

<script>
export default {
    name: "InputForm",
    props: ['modelValue', 'idinput', 'type', 'name', 'placeholder', 'isinvalid', "max", "min", "step", 'showable', 'disabled', 'required'],
    emits: ['update:modelValue'],
    data() {
        return {
            showinput: false,
        }
    },
    methods: {
        getClasses() {
            return {
                'form-control': true,
                'is-invalid': this.isinvalid,
                'show-input': this.type === 'password' && this.showinput == true
            }
        }
    },
}
</script>